import { Toast } from 'antd-mobile';
import { ExclamationCircleOutline } from 'antd-mobile-icons';
export default class ToastUtils {
    static showAbnormalToast(msg) {
        Toast.show({
            icon: <ExclamationCircleOutline />,
            content: msg,
            maskStyle: {
                zIndex: 10001
            }
        });
    }

    static showSuccessToast(msg) {
        Toast.show({
            icon: 'success',
            content: msg,
            maskStyle: {
                zIndex: 10001
            }
        });
    }

    static showToast(msg) {
        Toast.show({
            content: msg,
            maskStyle: {
                zIndex: 11000
            }
        });
    }
    static showGoBackAndRefreshToast(msg, icon = 'success', duration = 2000) {
        Toast.show({
            icon: icon,
            content: msg,
            duration: duration,
            maskStyle: {
                zIndex: 10001
            },
            afterClose: () => {
                window.history.back();

                // window.location.href = '/mobile' + goPath;
            }
        });
    }

    static showGoBackToast(msg) {
        // Toast.show({
        //     content: msg,
        //     afterClose: () => {
        //         let localPaths = Storage.get('routePaths'),
        //             routePaths = [];

        //         if (localPaths) {
        //             routePaths = JSON.parse(localPaths);
        //         }
        //         routePaths.pop();
        //         // goPath = topPath && `${topPath}` !== window.location.pathname ? topPath : '/';

        //         Storage.set('routePaths', JSON.stringify(routePaths));
        //         window.history.back();
        //     }
        // });

        Toast.show({
            content: msg,
            maskStyle: {
                zIndex: 10001
            },
            afterClose: () => {
                window.history.back();
            }
        });
    }
}
